module.exports = __webpack_public_path__ + "static/media/b&o_crop_052123.4ed2bc9f.png";